import { useTranslation } from "react-i18next"
import { Globe } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import {
  LOCALE_CONFIG,
  LOCALE_ORDER,
  isLocalDevHost,
} from "@/config/locale-domains"
import i18n from "@/i18n"

function switchLocale(targetLocale) {
  if (targetLocale === i18n.language) return

  if (isLocalDevHost()) {
    localStorage.setItem("dev_locale", targetLocale)
    i18n.changeLanguage(targetLocale)
    const cfg = LOCALE_CONFIG[targetLocale]
    document.documentElement.lang = cfg.htmlLang
    return
  }

  const target = LOCALE_CONFIG[targetLocale]
  const { pathname, search, hash, protocol } = window.location
  window.location.assign(`${protocol}//${target.domain}${pathname}${search}${hash}`)
}

export function LanguageSwitcher() {
  const { t, i18n: i18nInstance } = useTranslation()
  const current = i18nInstance.language?.startsWith("hu") ? "hu" : "ro"

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full gap-1.5 px-2.5"
          aria-label={t("language.label")}
          data-testid="language-switcher"
        >
          <Globe strokeWidth={1.5} className="h-4 w-4" />
          <span className="text-xs font-medium uppercase">{current}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LOCALE_ORDER.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => switchLocale(code)}
            className={current === code ? "font-medium" : ""}
            data-testid={`lang-${code}`}
          >
            {t(`language.${code}`)}
            <span className="ml-auto text-xs text-muted-foreground">
              {LOCALE_CONFIG[code].domain}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
